const header = document.querySelector("header");
const menuMob = document.querySelector("#menuMob");
const toggleMenu = document.querySelector("#toggleMenu");
const htmlOpen = document.documentElement;
let menuTrigger = null;
let mobileMenuTimeline = null;
let anchorScrollTween = null;

let headerHeight = header ? header.offsetHeight : 0;
const mobileMenuQuery = window.matchMedia("(max-width: 980px)");
function initSmoothPageScroll() {
	const canUseSmoothScroll = typeof Lenis !== "undefined"
		&& window.matchMedia("(pointer: fine)").matches
		&& !window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	if (!canUseSmoothScroll) {
		return;
	}

	const lenis = new Lenis({
		lerp: 0.16,
		smoothWheel: true,
		wheelMultiplier: 0.9,
		syncTouch: false,
	});

	lenis.on("scroll", () => {
		if (typeof ScrollTrigger !== "undefined") {
			ScrollTrigger.update();
		}
	});

	function smoothScrollFrame(time) {
		lenis.raf(time);
		requestAnimationFrame(smoothScrollFrame);
	}

	requestAnimationFrame(smoothScrollFrame);
}

const sectionOffset = 32;

function updateHeaderHeight() {
	headerHeight = header ? header.offsetHeight : 0;
}

function resetMobileMenuVisualState() {
	if (!menuMob) return;
	menuMob.classList.remove("open", "is-closing");
}

function getMobileMenuTimeline() {
	if (!mobileMenuQuery.matches || !menuMob || typeof gsap === "undefined") {
		return null;
	}

	if (mobileMenuTimeline) {
		return mobileMenuTimeline;
	}

	if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
		return null;
	}

	const links = [...menuMob.querySelectorAll("a"), header?.querySelector(".button")].filter(Boolean);
	mobileMenuTimeline = gsap.timeline({
		paused: true,
		onComplete: () => menuMob.querySelector("a")?.focus(),
		onReverseComplete: resetMobileMenuVisualState,
	});

	mobileMenuTimeline
		.fromTo(
			menuMob,
			{
				autoAlpha: 1,
				clipPath: "circle(0 at calc(100% - 3rem) 3.5rem)",
			},
			{
				clipPath: "circle(150vmax at calc(100% - 3rem) 3.5rem)",
				duration: 0.4,
				ease: "power2.out",
			},
		)
		.fromTo(
			links,
			{ autoAlpha: 0, y: 38, rotate: 1.5 },
			{ autoAlpha: 1, y: 0, rotate: 0, duration: 0.3, stagger: 0.055, ease: "power3.out" },
			0.22,
		);

	return mobileMenuTimeline;
}

function closeMobileMenu({ restoreFocus = false } = {}) {
	if (!menuMob || !toggleMenu) {
		return;
	}

	const wasOpen = menuMob.classList.contains("open");
	htmlOpen.classList.remove("menu-active");
	toggleMenu.classList.remove("active");
	toggleMenu.setAttribute("aria-expanded", "false");
	toggleMenu.setAttribute("aria-label", "Abrir menu");
	menuMob.inert = mobileMenuQuery.matches;

	const timeline = getMobileMenuTimeline();
	if (wasOpen && timeline && timeline.progress() > 0) {
		menuMob.classList.add("is-closing");
		timeline.reverse();
	} else {
		resetMobileMenuVisualState();
	}

	if (restoreFocus && menuTrigger) {
		menuTrigger.focus();
	}
}

let lastScrollY = window.scrollY;
let hideTimeout = null;
const hideDelay = 300;

function setHeaderSticky() {
	if (!header) {
		return;
	}

	const currentScrollY = window.scrollY;
	const isFixed = currentScrollY > 0;
	const isMenuOpen = menuMob && menuMob.classList.contains("open");

	header.classList.toggle("fixed", isFixed);

	if (!isFixed || isMenuOpen || currentScrollY < lastScrollY) {
		clearTimeout(hideTimeout);
		hideTimeout = null;
		header.classList.remove("hide");
	} else if (currentScrollY > lastScrollY && currentScrollY > headerHeight && !hideTimeout) {
		hideTimeout = setTimeout(() => {
			header.classList.add("hide");
			hideTimeout = null;
		}, hideDelay);
	}

	lastScrollY = currentScrollY;
}

let ticking = false;
function handleStickyOnScroll() {
	if (ticking) {
		return;
	}

	ticking = true;
	requestAnimationFrame(() => {
		setHeaderSticky();
		ticking = false;
	});
}

function scrollToSection(event) {
	if (!(event.target instanceof Element)) {
		return;
	}

	const link = event.target.closest('a[href^="#"]');
	if (!link) {
		return;
	}

	const href = link.getAttribute("href");
	if (!href || href === "#") {
		return;
	}

	let sectionId;
	try {
		sectionId = decodeURIComponent(href.slice(1));
	} catch (error) {
		return;
	}

	const section = document.getElementById(sectionId);
	if (!section) {
		return;
	}

	event.preventDefault();
	updateHeaderHeight();

	const isDeepScrollLink = link.classList.contains("deep-scroll-link");
	const sectionTop = section.getBoundingClientRect().top + window.scrollY;
	const offsetTop = isDeepScrollLink
		? Math.max(0, sectionTop - window.innerHeight * 0.58)
		: Math.max(0, sectionTop - headerHeight + sectionOffset);
	const shouldSlowDown = isDeepScrollLink
		&& typeof gsap !== "undefined"
		&& !window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	if (shouldSlowDown) {
		const scrollPosition = { y: window.scrollY };
		const previousScrollBehavior = document.documentElement.style.scrollBehavior;
		const finishScroll = () => {
			document.documentElement.style.scrollBehavior = previousScrollBehavior;
			anchorScrollTween = null;
		};

		anchorScrollTween?.kill();
		document.documentElement.style.scrollBehavior = "auto";
		anchorScrollTween = gsap.to(scrollPosition, {
			y: offsetTop,
			duration: 2,
			ease: "none",
			onUpdate: () => window.scrollTo(0, scrollPosition.y),
			onComplete: finishScroll,
			onInterrupt: finishScroll,
		});
	} else {
		window.scrollTo({
			top: offsetTop,
			behavior: "smooth",
		});
	}

	closeMobileMenu();
}

function openMenuMobile(event) {
	if (event) {
		event.preventDefault();
	}

	if (!menuMob || !toggleMenu) {
		return;
	}

	const isOpen = menuMob.classList.contains("open") && !menuMob.classList.contains("is-closing");
	if (isOpen) {
		closeMobileMenu({ restoreFocus: true });
		return;
	}

	menuTrigger = toggleMenu;
	header?.classList.remove("hide");
	menuMob.classList.add("open");
	menuMob.classList.remove("is-closing");
	htmlOpen.classList.add("menu-active");
	toggleMenu.classList.add("active");
	toggleMenu.setAttribute("aria-expanded", "true");
	toggleMenu.setAttribute("aria-label", "Fechar menu");
	menuMob.inert = false;

	const timeline = getMobileMenuTimeline();
	if (timeline) {
		timeline.play();
	} else {
		requestAnimationFrame(() => menuMob.querySelector("a")?.focus());
	}
}

function handleKeyboardNavigation(event) {
	if (event.key === "Escape") {
		closeMobileMenu({ restoreFocus: true });
	}
}

function syncMenuAccessibility() {
	if (!menuMob) return;

	if (!mobileMenuQuery.matches) {
		mobileMenuTimeline?.kill();
		mobileMenuTimeline = null;
		resetMobileMenuVisualState();
		menuMob.inert = false;

		if (typeof gsap !== "undefined") {
			gsap.set([menuMob, ...menuMob.querySelectorAll("a"), header?.querySelector(".button")].filter(Boolean), { clearProps: "all" });
		}
		return;
	}

	menuMob.inert = !menuMob.classList.contains("open");
}

function initNewsletterForm() {
	const form = document.querySelector(".newsletter-form");
	if (!form) return;

	const email = form.querySelector('input[type="email"]');
	const feedback = form.querySelector(".newsletter-feedback");

	form.addEventListener("submit", (event) => {
		event.preventDefault();

		if (!email?.checkValidity()) {
			if (feedback) feedback.textContent = "Informe um e-mail vÃ¡lido.";
			email?.focus();
			return;
		}

		if (feedback) feedback.textContent = "Cadastro recebido. Obrigado pelo interesse!";
		form.reset();
	});
}

function initFaqAccordion() {
	const faq = document.querySelector("#faq");
	if (!faq) {
		return;
	}

	const items = Array.from(faq.querySelectorAll(".faqItem"));
	if (!items.length) {
		return;
	}

	function setItemState(item, shouldOpen) {
		const button = item.querySelector(".faqQuestion");
		const answer = item.querySelector(".faqAnswer");

		if (!button || !answer) {
			return;
		}

		item.classList.toggle("open", shouldOpen);
		button.setAttribute("aria-expanded", String(shouldOpen));
		answer.style.maxHeight = shouldOpen ? `${answer.scrollHeight}px` : "0px";
	}

	items.forEach((item) => setItemState(item, false));

	faq.addEventListener("click", (event) => {
		if (!(event.target instanceof Element)) {
			return;
		}

		const button = event.target.closest(".faqQuestion");
		if (!button) {
			return;
		}

		const currentItem = button.closest(".faqItem");
		if (!currentItem) {
			return;
		}

		const shouldOpenCurrent = !currentItem.classList.contains("open");

		items.forEach((item) => {
			setItemState(item, item === currentItem && shouldOpenCurrent);
		});
	});

	let faqResizeFrame = null;
	window.addEventListener("resize", () => {
		if (faqResizeFrame) {
			cancelAnimationFrame(faqResizeFrame);
		}

		faqResizeFrame = requestAnimationFrame(() => {
			items.forEach((item) => {
				if (item.classList.contains("open")) {
					setItemState(item, true);
				}
			});
			faqResizeFrame = null;
		});
	}, { passive: true });
}

window.addEventListener("scroll", handleStickyOnScroll, { passive: true });
window.addEventListener("resize", updateHeaderHeight, { passive: true });
window.addEventListener("keydown", handleKeyboardNavigation);
document.addEventListener("click", scrollToSection);
toggleMenu?.addEventListener("click", openMenuMobile);
mobileMenuQuery.addEventListener("change", () => {
	closeMobileMenu();
	syncMenuAccessibility();
});

window.openMenuMobile = openMenuMobile;
window.openMenuMob = openMenuMobile;

function initPortfolioFilters() {
	const section = document.querySelector("#portfolioInternal");
	if (!section) return;

	const tabs = Array.from(section.querySelectorAll("[data-portfolio-tab]"));
	const panels = Array.from(section.querySelectorAll("[data-portfolio-panel]"));
	const cards = Array.from(section.querySelectorAll("[data-portfolio-category]"));

	if (!tabs.length || !panels.length) return;

	function setActiveTab(activeButton) {
		const activeTab = activeButton.dataset.portfolioTab || "projects";

		tabs.forEach((button) => {
			const isActive = button === activeButton;
			button.classList.toggle("active", isActive);
			button.setAttribute("aria-pressed", String(isActive));
			button.setAttribute("aria-selected", String(isActive));
		});

		panels.forEach((panel) => {
			panel.hidden = panel.dataset.portfolioPanel !== activeTab;
		});
	}

	function applyFilter(activeButton) {
		const filter = activeButton.dataset.portfolioFilter || "todos";
		setActiveTab(activeButton);

		cards.forEach((card) => {
			const cardCategories = (card.dataset.portfolioCategory || "").split(/\s+/);
			const shouldShow = filter === "todos" || cardCategories.includes(filter);
			card.hidden = !shouldShow;
		});
	}

	tabs.forEach((button) => {
		button.addEventListener("click", () => {
			if (button.dataset.portfolioFilter) {
				applyFilter(button);
				return;
			}

			setActiveTab(button);
		});
	});
}
function initSite() {
	const initializers = [
		initSmoothPageScroll,
		syncMenuAccessibility,
		updateHeaderHeight,
		setHeaderSticky,
		initFaqAccordion,
		initTeamSection,
		initPortfolioFilters,
		initNewsletterForm,
	];

	initializers.forEach((initializer) => {
		try {
			initializer();
		} catch (error) {
			console.error(`Falha ao inicializar ${initializer.name}:`, error);
		}
	});

	if (typeof window.initGsapAnimations === "function") {
		try {
			window.initGsapAnimations();
		} catch (error) {
			console.error("Falha ao inicializar as animaÃ§Ãµes:", error);
		}
	}
}

function initPreloader() {
	const preloader = document.querySelector("#preloader");
	const progressText = document.querySelector("#preloaderProgress");
	const progressBar = document.querySelector("#preloaderBar");
	const startedAt = performance.now();
	const minimumDuration = 850;
	const maximumDuration = 8000;
	let completed = 0;

	if (!preloader) {
		document.documentElement.classList.remove("is-preloading");
		initSite();
		return;
	}

	const imageTasks = Array.from(document.querySelectorAll("[data-preload]")).map((image) => {
		if (image.complete) return Promise.resolve();
		return new Promise((resolve) => {
			image.addEventListener("load", resolve, { once: true });
			image.addEventListener("error", resolve, { once: true });
		});
	});
	const tasks = [...imageTasks];

	function updateProgress() {
		const percentage = Math.round((completed / Math.max(tasks.length, 1)) * 100);
		if (progressText) progressText.textContent = `${percentage}%`;
		if (progressBar) progressBar.style.transform = `scaleX(${percentage / 100})`;
	}

	const trackedTasks = tasks.map((task) => Promise.resolve(task).finally(() => {
		completed += 1;
		updateProgress();
	}));
	const timeout = new Promise((resolve) => setTimeout(resolve, maximumDuration));

	Promise.race([Promise.allSettled(trackedTasks), timeout]).then(() => {
		const remaining = Math.max(0, minimumDuration - (performance.now() - startedAt));
		setTimeout(() => {
			if (progressText) progressText.textContent = "100%";
			if (progressBar) progressBar.style.transform = "scaleX(1)";
			preloader.classList.add("is-leaving");
			document.documentElement.classList.remove("is-preloading");
			preloader.addEventListener("transitionend", () => preloader.remove(), { once: true });
			setTimeout(() => preloader.remove(), 900);
			requestAnimationFrame(initSite);
		}, remaining);
	});
}

initPreloader();
function initTeamSection() {
	const section = document.querySelector("[data-team]");

	if (!section) {
		return;
	}

	const panel = section.querySelector("[data-team-panel]");
	const cityItems = Array.from(section.querySelectorAll("[data-team-city]"));
	const prevButton = section.querySelector("[data-team-prev]");
	const nextButton = section.querySelector("[data-team-next]");
	const hoverMedia = window.matchMedia("(hover: hover) and (pointer: fine)");
	const desktopPositions = [
		{ col: 2, row: 2 },
		{ col: 3, row: 1 },
		{ col: 1, row: 1 },
		{ col: 4, row: 2 },
		{ col: 3, row: 3 },
		{ col: 4, row: 4 },
		{ col: 1, row: 4 },
	];
	const responsivePositions = [
		{ col: 2, row: 2 },
		{ col: 3, row: 1 },
		{ col: 1, row: 1 },
		{ col: 1, row: 3 },
		{ col: 3, row: 3 },
	];
	const state = { page: 0 };

	if (!panel) {
		return;
	}

	function getCards() {
		return Array.from(panel.querySelectorAll(".team-card"));
	}

	function getDetail() {
		let detail = panel.querySelector(".team-detail");

		if (!detail) {
			detail = document.createElement("div");
			detail.className = "team-detail";
			detail.setAttribute("aria-hidden", "true");
			panel.appendChild(detail);
		}

		return detail;
	}

	function getColumns() {
		return window.matchMedia("(max-width: 1080px)").matches ? 3 : 4;
	}

	function getItemsPerPage() {
		return getColumns() === 3 ? responsivePositions.length : desktopPositions.length;
	}

	function getPosition(index) {
		if (getColumns() === 3) {
			return responsivePositions[index] || { col: index % 3 + 1, row: Math.floor(index / 3) + 1 };
		}

		return desktopPositions[index] || { col: index % 4 + 1, row: Math.floor(index / 4) + 1 };
	}

	function applyPosition(element, position) {
		element.style.gridColumn = String(position.col);
		element.style.gridRow = String(position.row);
	}

	function updateActiveCity(card) {
		const activeCity = card?.dataset.teamCardCity || "";

		cityItems.forEach((item) => {
			item.classList.toggle("active", item.dataset.teamCity === activeCity);
		});
	}

	function getNearestEmptyPosition(activePosition, occupied) {
		const columns = getColumns();
		const directions = [
			{ col: 1, row: 0 },
			{ col: -1, row: 0 },
			{ col: 0, row: 1 },
			{ col: 0, row: -1 },
		];

		for (const direction of directions) {
			const position = {
				col: activePosition.col + direction.col,
				row: activePosition.row + direction.row,
			};
			const key = `${position.col}:${position.row}`;

			if (position.col >= 1 && position.col <= columns && position.row >= 1 && !occupied.has(key)) {
				return position;
			}
		}

		return { col: activePosition.col, row: activePosition.row + 1 };
	}

	function updateDetail() {
		const detail = getDetail();
		const activeCard = getCards().find((card) => card.classList.contains("active") && !card.classList.contains("is-hidden"));

		if (!activeCard) {
			detail.classList.remove("active");
			detail.setAttribute("aria-hidden", "true");
			updateActiveCity(null);
			return;
		}

		const activePosition = {
			col: Number(activeCard.dataset.teamCol),
			row: Number(activeCard.dataset.teamRow),
		};
		const occupied = new Set(
			getCards()
				.filter((card) => !card.classList.contains("is-hidden"))
				.map((card) => `${card.dataset.teamCol}:${card.dataset.teamRow}`),
		);
		const detailPosition = getNearestEmptyPosition(activePosition, occupied);
		const name = activeCard.querySelector(".team-info strong")?.textContent || "";
		const role = activeCard.querySelector(".team-info small")?.textContent || "";

		detail.classList.remove("active");
		detail.replaceChildren();
		const nameElement = document.createElement("strong");
		const roleElement = document.createElement("small");
		nameElement.textContent = name;
		roleElement.textContent = role;
		detail.append(nameElement, roleElement);
		applyPosition(detail, detailPosition);
		void detail.offsetWidth;
		detail.classList.add("active");
		detail.setAttribute("aria-hidden", "false");
		updateActiveCity(activeCard);
	}

	function setActiveCard(card) {
		getCards().forEach((item) => {
			const isActive = item === card;
			item.classList.toggle("active", isActive);
			item.setAttribute("aria-current", String(isActive));
		});
		updateDetail();
	}

	function updateTeam() {
		const cards = getCards();
		const itemsPerPage = getItemsPerPage();
		const pageCount = Math.max(1, Math.ceil(cards.length / itemsPerPage));
		state.page = Math.min(state.page, pageCount - 1);

		const start = state.page * itemsPerPage;
		const end = start + itemsPerPage;
		let activeCardVisible = false;

		cards.forEach((card, index) => {
			const isVisible = index >= start && index < end;
			const pageIndex = index - start;
			const position = getPosition(pageIndex);

			card.classList.toggle("is-hidden", !isVisible);
			card.setAttribute("aria-current", String(card.classList.contains("active")));

			if (isVisible) {
				card.dataset.teamCol = String(position.col);
				card.dataset.teamRow = String(position.row);
				applyPosition(card, position);
			}

			if (isVisible && card.classList.contains("active")) {
				activeCardVisible = true;
			}
		});

		if (!activeCardVisible && cards[start]) {
			setActiveCard(cards[start]);
		} else {
			updateDetail();
		}

		if (prevButton) {
			prevButton.disabled = state.page === 0;
		}

		if (nextButton) {
			nextButton.disabled = state.page >= pageCount - 1;
		}
	}

	function activateEventCard(event) {
		if (!(event.target instanceof Element)) {
			return;
		}

		const card = event.target.closest(".team-card");

		if (!card || card.classList.contains("active")) {
			return;
		}

		setActiveCard(card);
	}

	panel.addEventListener("pointerover", (event) => {
		if (hoverMedia.matches) {
			activateEventCard(event);
		}
	});

	panel.addEventListener("focusin", activateEventCard);
	panel.addEventListener("click", (event) => {
		if (!hoverMedia.matches) {
			activateEventCard(event);
		}
	});

	if (prevButton) {
		prevButton.addEventListener("click", () => {
			state.page = Math.max(0, state.page - 1);
			updateTeam();
		});
	}

	if (nextButton) {
		nextButton.addEventListener("click", () => {
			const cards = getCards();
			const pageCount = Math.max(1, Math.ceil(cards.length / getItemsPerPage()));
			state.page = Math.min(pageCount - 1, state.page + 1);
			updateTeam();
		});
	}

	let teamResizeFrame = null;
	window.addEventListener("resize", () => {
		if (teamResizeFrame) cancelAnimationFrame(teamResizeFrame);
		teamResizeFrame = requestAnimationFrame(updateTeam);
	}, { passive: true });
	updateTeam();
}